module.exports = __webpack_public_path__ + "img/featuredartist15 (6).45d916e6.jpg";